<template>
<div style="height:100%" id="mainFrame">
  <v-row v-if="loadingProgress == 100">
    <v-col cols="7">
       <h1>Fragen</h1>
    </v-col>
    <v-col cols="5" class="question-actions">
        <v-text-field
            v-model="search"
            label="Fragen durchsuchen"
            class="mx-4"
            clearable
            prepend-icon="search"
        ></v-text-field>
      <v-btn color="primary" medium elevation="0" @click="$router.push('/createPXQuestion')">
        <v-icon color="#F5F5F5" medium>add</v-icon > Neue Frage
      </v-btn>
    </v-col>
  </v-row>
      <v-tabs left fixed-tabs v-model="tab" color="secondary">
    <v-tab id="tab" key="all">Alle Fragen
      <v-chip id="chip" color="white">{{ pxQuestions != null ? pxQuestions.length : '0'}}</v-chip>
      <v-spacer/>
    </v-tab>
    <v-tab id="tab" key="own">Meine Fragen 
      <v-chip id="chip" color="white">{{ ownQuestions != null ? ownQuestions.length : '0'}}</v-chip>
      <v-spacer/>
    </v-tab>
    <v-tab id="tab" key="shared">Mandantenfragen
      <v-chip id="chip" color="white">{{ clientQuestions != null ? clientQuestions.length : '0'}}</v-chip>
      <v-spacer/>
    </v-tab>
  </v-tabs>
  <div style="overflow:auto;" >
        <v-main style="margin:5px; padding: 0;">
            <v-data-table
            :headers="headers"
            :items="retrieveQuestionItems()"
            :items-per-page="15"
            :search="search"
            sort-by="createdDate"
            :sort-desc="true"
            >
            <template v-slot:item.text="{ item }">
              <span>
                <div v-if="checkForNewQuestion(item)" class="new-item">
                  <span class="new-item__text">NEU</span>
                </div>
                {{item.text}}
              </span>
            </template>
            <template v-slot:item.createdDate="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span class="date cursor-default" color="gray_3" v-bind="attrs" v-on="on" style="vertical-align: center;">{{ item.createdDate ? new Date(item.createdDate).toLocaleString('de-DE', {day: 'numeric',
                      month: 'short', year: 'numeric'}) : "-" }}</span>
                </template>
                <span>{{ item.createdDate ? new Date(item.createdDate).toLocaleString('de-DE') : "-" }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.userId="{ item }">
              <span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <span class="cursor-default" v-bind="attrs" v-on="on">
                        <v-avatar
                            v-if="getCreator(item) != '-'"
                            color="gray_2"
                            size="32"
                            style="color: #fff;"
                        >{{initials(getCreator(item))}}</v-avatar>
                        <span v-else class="date">{{ getCreator(item) }}</span>
                      </span>
                  </template>
                  <span>{{ getCreator(item) }}</span>
                </v-tooltip>
              </span>
            </template>
            <template v-slot:item.answerType="{ item }">
              <span class="date cursor-default">{{ decodeQuestionType(item.answerType) }}</span>
            </template>
            <template v-slot:item.module="{ item }">
              <v-chip v-if="item.module != 'NONE'" small outlined color="gray_3" text-color="gray" class="module-tag">
                {{decodeModuleNameByEnum(item.module) }}
              </v-chip>
              <span v-else class="date cursor-default">{{decodeModuleNameByEnum(item.module) }}</span>
            </template>
            <template v-slot:item.element="{ item }">
              <span class="date cursor-default">{{ decodeElementByName(getElement(item)) }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-btn 
                      :disabled="item.createdBy == null" 
                      color="gray" 
                      small 
                      text 
                      @click="item.createdBy != null && removeQuestion(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>{{ item.createdBy != null ? 'Frage löschen' : 'Standardfragen können nicht gelöscht werden' }}</span>
              </v-tooltip>
            </template>



            </v-data-table>
        </v-main>
  </div>
  <NewProcessModePicker ref="newProcessModePicker" />
  <NewProcessDialog v-model="showCreateDialog" />
  <ImportProcessDialog v-model="showImportDialog" />
  <ConfirmDialog ref="confirmDialog" />
  <v-progress-linear
      :style="'position: absolute; left: 0; bottom: 0; display: '+(loadingProgress == 100 ? 'none;' :
      'block; z-index:99;')"
      color="gray accent-4"
      :indeterminate="loadingProgress == 100 ? false : true"
      height="4"
      :value="loadingProgress"
  ></v-progress-linear>
</div>
</template>

<script>
import pxQuestionService from './px-question-service'
import pxSurveyGenerator from "@/components/px-survey-generator"
import {decodeModuleNameByEnum, decodeElementByName, decodeQuestionType} from '@/components/util.js'
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
export default {
  components: { ConfirmDialog },
  data: () => ({
    selectedAnswerType: '',
    selectedQuestionOption: '',
    questionText: '',
    pxQuestions: [],
    search: '',
    headers: [
        { text: 'Fragentext', value: 'text' },
        { text: 'Erstellt am', value: 'createdDate', dataType: "Date" },
        { text: 'Erstellt von', value: 'userId' },
        { text: 'Antworttyp', value: 'answerType' },
        { text: 'Modul', value: 'module' },
        { text: 'Element', value: 'element' },
        { text: 'Aktion', value: 'action' },
      ],
    selectedAssignees: [],
    snackbar: false,
    snackTimeout: 2200,
    possibleAssignees: [],
    previewSchema: {},
    tab: 0,
    loadingProgress: 0,
    processPxQuestions: []
  }),
  mounted() {
      this.fetchPxQuestions();
      
  },
  computed:{
    userId(){
      return this.$store.state.user.username;
    },
    ownQuestions(){
      if(this.pxQuestions == null) return [];
      if(this.pxQuestions.length > 0){
        return this.pxQuestions.filter(elem => elem.createdBy != null && elem.createdBy == this.userId);
      }
    },
    clientQuestions(){
      if(this.pxQuestions == null) return [];
      if(this.pxQuestions.length > 0){
        return this.pxQuestions.filter(elem => elem.userId != null && elem.userId != this.userId);
      }
    }
  },
  methods: {
      decodeQuestionType:decodeQuestionType,
      decodeElementByName:decodeElementByName,
      decodeModuleNameByEnum: decodeModuleNameByEnum,
      checkForNewQuestion(item){
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(item.createdDate);
        const secondDate = new Date();

        const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
        return diffDays <= 7 ? true : false;
      },
      retrieveQuestionItems(){
        if(this.tab == 0){
            return this.pxQuestions;
        }else if( this.tab == 1){
            return this.ownQuestions;
        }else if(this.tab == 2){
            return this.clientQuestions;
        }
      },
      selectAnswerType(){
        this.previewSchema = pxSurveyGenerator.buildQuestion(this.selectedAnswerType);
      },
      submitQuestion(){
          const question = {
              text: this.questionText,
              type: this.selectedQuestionOption
          }
          pxQuestionService.savePXQuestion(question).then((res) => {
              this.fetchPxQuestions();
          })
      },
      getCreator(item){
        return item.createdBy == null ? "-":item.createdBy;
      },
      getElement(item){
        if('element' in item) return item.element;
        return "-";
      },
      fetchPxQuestions(){
        this.loadingProgress = 0;
          pxQuestionService.retrievePXQuestionOverview().then((result) => {
              this.pxQuestions = result.data;
              pxQuestionService.retrievePXProcessBasedQuestionOverview().then((result) => {
                this.pxQuestions.push(...result.data);
                this.loadingProgress = 100;
              })
          })
      },
    initials(email){
      let initials = email.substring(0,2).toUpperCase();
      return initials;
    },
    removeQuestion(item){
      this.$refs.confirmDialog
      .open(
        "Frage löschen",
        "Möchten Sie die Frage: "+item.text+" wirklich löschen? Die Frage wird weiterhin in den bestehenden Umfragen verwendet, kann jedoch nicht mehr für neue Umfragen ausgewählt werden"
      )
      .then(async () => {
        if(item.module == "Module_Four"){
          await pxQuestionService.removePBQuestion(item.id);
        }else{
          await pxQuestionService.removePXQuestion(item.id);
        }
        this.fetchPxQuestions();
      })
      .catch(e => next())
    }
  },
};
</script>
<style scoped>
.question-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
}
.frame{
    border: 1px solid lightgray;
    margin:5px;
}
.filter{
    width:10%;
    float:right;
    margin-right: 10px;

}
.table-header{
    padding:0 !important
}
.v-tab--active{
  color:initial !important;
}
#tab{
  max-width:unset;
}
#tab.active{
  font-size: 10rem;
}
#chip{
  margin-left: 10px;
}
.white{
  color: var(--v-secondary-base) !important;
}
.v-tab--active{
  color:initial;
}
.v-tab--active > .v-chip{
  background-color: var(--v-secondary-base) !important;
  color: #F5F5F5 !important;
}
:deep th {
  height: 60px !important;
}
:deep td:first-child {
  width: 40vw;
}
.new-item {
  position: relative;
  display: inline;
  padding: 0 4px;
}
.new-item::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  content: '';
  background-color: var(--v-primary-base);
  opacity: 0.1;
}
.new-item__text {
  color: var(--v-primary-base);
  font-weight: 700;
  letter-spacing: 1.5px;
  font-size: 0.6rem;
  text-transform: uppercase;
  height: 0.6rem;
  vertical-align: middle;
}
</style>